import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import Modal from '../../Modal';
import MobileMenu from '../../MobileMenu';
import CitySelector from '../../CitySelector';

import { getHeaderLogoSrc } from '../headerLogo';
import { CITY_THEME_DISNEY, CITY_THEME_MOTHERS_DAY, isThemeActive, isVisualThemeActive } from '../../../utils/cityTheme';

// Router
import { getRoute } from '../../../entry/routes';

// Config
import config from '../../../config';

// Styles
import styles from './MobileView.styl';

const cx = classNames.bind(styles);

export default function MobileView(props) {
  const { className } = props;

  const locale = useSelector(state => state.intl.locale);
  const userCity = useSelector(state => state.city.userCity);
  const [isOpen, setIsOpen] = useState(false);

  const lang = config.legal === 'kz' || config.legal === 'kg' ? 'en' : locale;
  const logoSrc = getHeaderLogoSrc(lang, userCity);
  const isDisneyTheme = isVisualThemeActive(userCity, CITY_THEME_DISNEY);
  const isMothersDayTheme = isThemeActive(userCity, CITY_THEME_MOTHERS_DAY);

  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <header className={cx('Header', className)}>
      <Link
        to={getRoute('home')}
        className={cx('Header__logo', {
          Header__logo_disney: isDisneyTheme,
          Header__logo_mothersDay: isMothersDayTheme,
        })}
      >
        <img src={logoSrc} alt="Papa John's" />
      </Link>
      <CitySelector className={cx('Header__city')} />
      <div
        className={cx('Header__hamburger')}
        onClick={toggle}
        onKeyDown={e => e.key === 'Enter' && toggle()}
        role="button"
        tabIndex={0}
      >
        <div className={cx('Header__hamburger-line')} />
        <div className={cx('Header__hamburger-line')} />
        <div className={cx('Header__hamburger-line')} />
      </div>
      <Modal isOpen={isOpen} onClose={toggle} direction="left">
        <MobileMenu onClose={toggle} />
      </Modal>
    </header>
  );
}

MobileView.defaultProps = {
  className: '',
};

MobileView.propTypes = {
  className: PropTypes.string,
};
